export default __webpack_public_path__ + "static/media/analytics.a7f2f92e.svg";